import gql from 'graphql-tag';
import { CONTAINER } from './fragments';
import { CONTAINER_LOADING } from './fragments';

export const UPDATE_CONTAINER = gql`
  ${CONTAINER}
  mutation updateContainers($input: [UpdateContainerInput]) {
    updateContainers(input: $input) {
      ...container
    }
  }
`;

export const UPDATE_LOADING_CONTAINER = gql`
  ${CONTAINER_LOADING}
  mutation updateContainers($input: [UpdateContainerInput]) {
    updateContainers(input: $input) {
      ...container
    }
  }
`;

export const CREATE_GET_NUVO_DELIVERIES = gql`
  mutation createGetNuvoDeliveries($input: [CreateGetNuvoDeliveryInput!]) {
    createGetNuvoDeliveries(input: $input) {
      id
    }
  }
`;
